// Load class that creates the grid with integrations
import ItemCreatorIntegrations from '@builder-legacy/item/integrations-grid';

// Import dependencies
import { html, LitElement } from 'lit';
import { customElement, property, query } from 'lit/decorators.js';
import { repeat } from 'lit/directives/repeat.js';
const { debounce, isDefined, isEmpty } = _uo.utility;

// eslint-disable-next-line require-jsdoc
@customElement( 'uap-builder-item-loop-add-action' )
export class AutomatorBuilderItemAddAction extends LitElement {
	// The ID of the parent
	@property( { type: Number, attribute: 'loop-id' } ) accessor loopID;

	// The wrapper element
	@query( '.uap-item-loop-new-action-wrapper' ) accessor $wrapper;

	/**
	 * Disable the Shadow DOM
	 *
	 * @todo Remove this once we move fields to web components
	 * @return {HTMLElement} The component
	 */
	createRenderRoot() {
		return this;
	}

	// eslint-disable-next-line require-jsdoc
	render() {
		return html`
			<div class="uap-item-loop-new-action-wrapper"></div>
        `;
	}

	/**
	 * Creates a new instance of the ItemCreatorIntegrations and renders its elements in the wrapper of
	 * this component.
	 */
	firstUpdated() {
		new ItemCreatorIntegrations( 'action', this.$wrapper, {
			parentID: this.loopID
		} );
	}
}
